import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { PageMetadata } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  constructor(
    private meta: Meta,
    private title: Title,
  ) {}

  updateMetaTags(metadata: PageMetadata): void {
    // Set page title
    this.title.setTitle(metadata.title);

    // Update or add standard meta tags
    this.meta.updateTag({ name: 'description', content: metadata.description || '' });
    if (metadata.keywords) {
      this.meta.updateTag({ name: 'keywords', content: metadata.keywords });
    } else {
      this.meta.removeTag('name="keywords"');
    }

    // Update or add Open Graph meta tags
    const ogTitle = metadata.ogTitle || metadata.title;
    this.meta.updateTag({ property: 'og:title', content: ogTitle });

    const ogDescription = metadata.ogDescription || metadata.description || '';
    this.meta.updateTag({ property: 'og:description', content: ogDescription });

    if (metadata.ogImage) {
      this.meta.updateTag({ property: 'og:image', content: metadata.ogImage });
    } else {
      this.meta.removeTag('property="og:image"');
    }

    // Set OG type
    this.meta.updateTag({ property: 'og:type', content: metadata.ogType || 'website' });

    // Set article-specific meta tags
    if (metadata.ogType === 'article') {
      if (metadata.articlePublishedTime) {
        this.meta.updateTag({
          property: 'article:published_time',
          content: metadata.articlePublishedTime,
        });
      }
      if (metadata.articleAuthor) {
        this.meta.updateTag({ property: 'article:author', content: metadata.articleAuthor });
      }
      if (metadata.articleSection) {
        this.meta.updateTag({ property: 'article:section', content: metadata.articleSection });
      }
    } else {
      // Remove article tags if not an article
      this.meta.removeTag('property="article:published_time"');
      this.meta.removeTag('property="article:author"');
      this.meta.removeTag('property="article:section"');
    }

    // Set robots meta tag
    if (metadata.robots) {
      this.meta.updateTag({ name: 'robots', content: metadata.robots });
    } else {
      this.meta.removeTag('name="robots"');
    }
  }
}
